const DEFAULT_POLLING_INTERVAL = 1000;
const DEFAULT_POLLING_RETRIES_AMOUNT = 100;

export { DEFAULT_POLLING_INTERVAL, DEFAULT_POLLING_RETRIES_AMOUNT };
